import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Hanhkhachtonghop from "components/Duongthuy/Hanhkhach/Hanhkhachtonghop.js";
export default function HanhkhachTH() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo số lượng hành khách",
            tabContent: <Hanhkhachtonghop />,
          },
        ]}
      />
    </div>
  );
}
